import React from 'react';
import { useTranslation } from 'react-i18next';
import '../styles/DesignSection.css';

function DesignSection({ isMobile }) {
  const { t } = useTranslation();
  
  // 移动端和桌面端使用不同的渲染内容
  const renderContent = () => {
    if (isMobile) {
      return (
        <>
          <h2 className="design-title design-title-mobile">
            {t('design.exhilaratingDesign')}
          </h2>
          <div className="design-background design-background-mobile">
            <div className="design-image-container">
              <img 
                src="/images/page3.png" 
                alt="BOBO robot with heart eyes" 
                className="design-image" 
              />
            </div>
          </div>
          <div className="design-content design-content-mobile">
            <p className="design-description design-description-mobile">
              {t('design.bringsTogether')}
            </p>
          </div>
        </>
      );
    } else {
      // 桌面端渲染内容
      return (
        <>
          <div className="design-background"></div>
          <div className="design-content">
            <h2 className="design-title">{t('design.exhilaratingDesign')}</h2>
            <p className="design-description">
              {t('design.bringsTogether')}
            </p>
          </div>
        </>
      );
    }
  };

  return (
    <section className={`design-section ${isMobile ? 'design-section-mobile' : ''}`} id="design">
      {renderContent()}
    </section>
  );
}

export default DesignSection; 